import { JsonSerializable } from '@/util/object/JsonSerializable'
import { FulfillmentStatus } from '@/cowboy/EnumTypes'
import { OrderLineItemResponse } from '@/cowboy/order/object/OrderLineItemResponse'
import { MoneyResponse } from '@/cowboy/order/object/MoneyResponse'

export class OrderResponse extends JsonSerializable {
  /** @type {string} */
  #referenceOrderID
  /** @type {FulfillmentStatus} */
  #status
  /** @type {MoneyResponse} */
  #orderTotal
  /** @type {Array<OrderLineItemResponse>} */
  #lineItems

  constructor (jsonObject) {
    super()
    this.#referenceOrderID = jsonObject.referenceOrderID
    this.#status = FulfillmentStatus.fromJSON(jsonObject.status)
    this.#orderTotal = MoneyResponse.fromJSON(jsonObject.orderTotal)
    this.#lineItems = jsonObject.lineItems?.map(OrderLineItemResponse.fromJSON) || []
    Object.freeze(this)
  }

  /**
   * Order identifier
   * @return {string}
   */
  get referenceOrderID () {
    return this.#referenceOrderID
  }

  get status () {
    return this.#status
  }

  get orderTotal () {
    return this.#orderTotal
  }

  get lineItems () {
    return this.#lineItems
  }

  /**
   * @return {Object}
   */
  toJSON () {
    return {
      referenceOrderID: this.#referenceOrderID,
      status: this.#status?.toJSON(),
      orderTotal: this.#orderTotal?.toJSON(),
      lineItems: this.#lineItems?.map(lineItem => lineItem.toJSON())
    }
  }

  /**
   * @param {Object} jsonObject
   * @return {OrderResponse|undefined}
   */
  static fromJSON (jsonObject) {
    return (jsonObject && new OrderResponse(jsonObject)) || undefined
  }
}
